<template>
  <div>
    <PaymentResult v-if="getMerchant.theme == 'ZOO'"></PaymentResult>
    <NormalTemplateV2 v-else-if="getMerchant.is_special_merchant"></NormalTemplateV2>
    <NormalTemplate v-else></NormalTemplate>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import NormalTemplate from './TicketOrderHistoryDetail'
  import NormalTemplateV2 from './TicketPaymentForm'
  import PaymentResult from './custom/PaymentResult.vue';
  
  export default {
    components:{
      NormalTemplate,
      PaymentResult,
      NormalTemplateV2
    },
    computed:{
      ...mapGetters(['getMerchant']),
      is_mobile_view(){
				return window.innerWidth > 768 ? false : true
			}
    }  
  }
</script>


// WEBPACK FOOTER //
// src/pages/ticket/TicketOrderHistoryDetailWrapper.vue